import classNames from "classnames"
import React from "react"

export default function Toggle({ mode, setMode }) {
  return (
    <div className=" flex rounded-full text-xs md:text-sm cursor-pointer select-none">
      <div
        className={classNames("rounded-l-full px-3 py-1 ", {
          "bg-slate-300 dark:bg-slate-500 text-slate-800 dark:text-slate-200 font-medium":
            mode == "organize",
          "bg-slate-200 dark:bg-slate-700 text-slate-600 dark:text-slate-500":
            mode != "organize",
        })}
        onClick={() => setMode("organize")}
      >
        Organize
      </div>
      <div
        className={classNames("rounded-r-full px-3 py-1 ", {
          "bg-slate-300 dark:bg-slate-500  text-slate-800 dark:text-slate-200 font-medium":
            mode == "draft",
          "bg-slate-200 dark:bg-slate-700 text-slate-600 dark:text-slate-500":
            mode != "draft",
        })}
        onClick={() => setMode("draft")}
      >
        See draft
      </div>
    </div>
  )
}
